import React, {useState,useEffect} from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
//fonction qui permet de recuperer les casques qui sont en stock dans une liste deroulante
function Main(props){
    const {casqueDote, setCasqueDote} = props;
    const [Data, setData] = useState([]);

    //permet de recuperer le casque selectionner et le mettre dans la variable casqueDote
    const handleChange = (event,newvalue) => {
        setCasqueDote(newvalue);
    }

    //me permet de recuper les casques qui sont en stock
    useEffect(() => {
        const fetchData = async () => {
          try {
            let url = "/php/CasqueStock.php";
            if(window.location.hostname === "localhost" || window.location.port === "3000"){
              url = 'http://localhost/php/CasqueStock.php';
            }
            const response = await fetch(url);
            const jsonData = await response.json();
            setData(jsonData);
          } catch (error) {
            console.error('Erreur lors de la récupération des données de la bdd:', error);
          }
        };
      
        fetchData();
      }, []);

      return(
        <Box display={"flex"} flexDirection="column" alignItems={'center'} justifyContent={"center"} key={28} sx={{marginTop:"15px"}}>
          <Box fontSize="small" color={"red"} marginBottom={"10px"}>Le numéro de série est sur la (Fiche/Prise)</Box>
          <Autocomplete
              disablePortal
              id="Casque Rendu"
              value={casqueDote}
              options={Data}
              getOptionLabel={(option) => option}
              sx={{ width: 300 }}
              key={29}
              onChange={handleChange}
              renderInput={(params) => <TextField {...params} label="Casque pris" />}
          />
        </Box>
      )
}   
export default Main;